import React from "react";

export default function AccountButton({
  children,
  onClick,
  type = "button",
  className = "",
  disabled = false,
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`w-full py-3 font-bold text-white text-base bg-gradient-to-r from-[#445eed] to-[#2d348f] hover:from-[#3916ab] hover:to-[#4962d8] transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {children}
    </button>
  );
}
